import React, { Component } from "react";

export default class Cell extends Component {
  render() {
    let elementClass = "col d-flex justify-content-center align-items-center p-0";
    let myStyle = {
      background: "white",
      background: "white",
      fontSize: 20 + "px",
      cursor: "pointer",
      color: "#333",
    }
    if (this.props.cell.animation) {
      if(this.props.cell.animation === 'textBlink') {
        myStyle = {
          ...myStyle,
          animation: 'textBlink',
          animationDuration: '2s',
          animationIterationCount: 1000
        }
      } else if(this.props.cell.isUsed) {
        myStyle = {
          ...myStyle,
          background: "rgb(244, 255, 199)",
        }
      }
      myStyle = {
        ...myStyle,
        animation: this.props.cell.animation + ' 1s'
      }
    }
    return (
      <div
        className={elementClass}
        onClick={this.props.onCellClick}
        style={myStyle}
      >
        <span className=''>{this.props.cell.value}</span>
      </div>
    );
  }
}
